import { Pipe } from "@angular/core";

@Pipe({
    name: 'customFieldsFilter',
    pure: true
})

export class CustomFieldsFilter {

    transform(array: any[], object: {}) {
        if (Object.keys(object).length <= 0) {
            return array;
        } else {
            var objectKeys = Object.keys(object);
            return array.filter(obj => {

                var isMatched = false;
                var count = 0;
                for (let key of objectKeys) {
                   count ++;
                    var eKeyVal = object[key];
                    
                    var objKeyVal = obj[key];
                    if(typeof(eKeyVal) == "boolean"){
                        if(eKeyVal == true && objKeyVal){
                            isMatched = true;

                        }
                        if(eKeyVal == false && !objKeyVal){
                            isMatched = true;
                        }
                    }
                    if (objKeyVal && eKeyVal) {
                        if (objKeyVal instanceof Array) {
                            for (let item of objKeyVal) {
                                if (typeof(item) == "string") {
                                    if (item.toLowerCase() == eKeyVal.toString().toLowerCase()) {
                                        isMatched = true;
                                    }
                                } else if (typeof(item) == "number") {
                                    if (item == Number(eKeyVal)) {
                                        isMatched = true;
                                    }
                                }
                            }
                        } else if (typeof(objKeyVal) == "string") {
                            if (eKeyVal instanceof Array) {
                                if(eKeyVal.includes(objKeyVal)){
                                    isMatched = true;
                                }
                            }else {
                                if (objKeyVal.toLowerCase() == eKeyVal.toString().toLowerCase()) {
                                    isMatched = true;
                                }
                            }
                            
                        } else if (typeof(objKeyVal) == "number") {
                            if (eKeyVal instanceof Array) {
                                if(eKeyVal.includes(objKeyVal)){
                                    isMatched = true;
                                }
                            }else if (objKeyVal == Number(eKeyVal)) {
                                isMatched = true;
                            }
                        } else {
                            if (JSON.stringify(objKeyVal).includes(eKeyVal.toString().toLowerCase())) {
                                isMatched = true;
                            }
                        }
                        // if (obj[key] && obj[key].toString().toLowerCase().includes(searchText)) {
                        //     return obj;
                        // }

                        // if(count < objectKeys.length){
                        //     if(isMatched == true){
                        //         isMatched = false;
                        //     }else{
                        //         return;
                        //     }
                        // }
                    }
                }
                if(isMatched == true){
                    return obj;
                }

            });

        }
    }
}
